/* eslint-disable arrow-body-style */
import { Modal } from '@mui/material';
import { StyledSectionModalBox } from '../../styles';
import { Item } from 'src/@types/Course';
import NewSectionItemForm from 'src/sections/@dashboard/course/NewSectionItemForm';
import { Dispatch, SetStateAction, useState } from 'react';

export const SectionItemModal = ({
  open,
  handleClose,
  isEdit,
  currentItem,
  onSubmit,
  modalStep,
  setModalStep,
}: {
  open: boolean;
  handleClose(): void;
  isEdit: boolean;
  currentItem: Item | undefined;
  onSubmit(item: any): void;
  modalStep: number;
  setModalStep: Dispatch<SetStateAction<number>>;
}) => {

  return (
    <Modal
      open={open}
      onClose={() => {
        setModalStep(0);
        handleClose();
      }}
    >
      <StyledSectionModalBox sx={{ width: '50%' }}>
        <NewSectionItemForm
          handleClose={() => {
            setModalStep(0);
            handleClose();
          }}
          isEdit={isEdit}
          currentItem={currentItem}
          onSubmit={onSubmit}
          modalStep={currentItem ? 1 : modalStep}
          setModalStep={(step: number) => setModalStep(step)}
        />
      </StyledSectionModalBox>
    </Modal>
  );
};
